<app-leveltwo [pageName]="'Veterans Exemption'">
  <div class="General">

      <h3>{{'Veterans.SearchTitle'|translate}}</h3>
      <p>{{'Veterans.Ifyousingle'|translate}}</p>
      <p>{{'Veterans.IfyouHOX'|translate}}</p>
      <!-- <p>{{'Veterans.TheAssessor'|translate}}</p> -->
      <div class="vet-info">
        <p [innerHTML]="'Veterans.Formore'|translate"></p>
        <!-- <p>{{'Veterans.MajorExemptions' | translate}}</p>
        <p>{{'Veterans.Call'|translate}}: <b>(213)974-3399</b></p>
        <p>{{'Veterans.email'|translate}}: <a href="mailto:exempt@assessor.lacounty.gov " target="_blank">exempt@assessor.lacounty.gov</a></p> -->
      </div>



  </div>
</app-leveltwo>

